import React from 'react';

import Text from '~/components/core/TextComponents/Text';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';

interface NotePropsType {
  contact: ContactFullModel;
}

const Note: React.FC<NotePropsType> = ({ contact }) => {
  return (
    <>
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD}>
        Note
      </Text>
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
        {contact.note || '-'}
      </Text>
    </>
  );
};

export default Note;
